import { getContrast, getLuminance, readableColor } from 'polished';

import { ColorProp } from './theme';

export function isColorProp(
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    color: ColorProp | (string & {})
): color is ColorProp {
    return typeof color === 'string' && !color.startsWith('#');
}

export function isColorDark(color: string) {
    return getLuminance(color) < 0.5;
}

export function getReadableTextColor(
    bgColor: string,
    preferredTextColor: string
): string {
    if (bgColor === 'inherit' || preferredTextColor === 'inherit') {
        return preferredTextColor;
    }

    const contrastRatio = getContrast(bgColor, preferredTextColor);
    const AA_NORMAL_THRESHOLD = 4.5;

    if (contrastRatio >= AA_NORMAL_THRESHOLD) {
        return preferredTextColor;
    }

    return readableColor(bgColor, '#000000', '#FFFFFF', false);
}
